import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveTable = _resolveComponent("ActiveTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.page)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title)
    }, _toDisplayString(_ctx.t('companies.title')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _createVNode(_component_ActiveTable, {
        id: "organisations_table",
        sort: _ctx.sort,
        "onUpdate:sort": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sort) = $event)),
        "filters-model": _ctx.filtersModel,
        "onUpdate:filters-model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersModel) = $event)),
        "table-key": "organizations",
        class: _normalizeClass(_ctx.$style.table),
        "key-field": _ctx.keyField,
        columns: _ctx.columns,
        filters: _ctx.filters,
        records: _ctx.records,
        actions: _ctx.actions,
        state: "default",
        "is-selectable": "",
        "with-unique-selection": "",
        "initially-selected-items": [_ctx.companyId],
        "selectable-column": "index",
        onSelect: _ctx.onSetDefaultCompanyId,
        onRowClick: _ctx.onRowClick
      }, null, 8, ["sort", "filters-model", "class", "key-field", "columns", "filters", "records", "actions", "initially-selected-items", "onSelect", "onRowClick"])
    ], 2)
  ], 2))
}